import { useState } from 'react';

import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';
import { Slogan } from '@/components/Slogan';
import { StoreInput } from '@/UserInput/Store';

import { StoreSelectorButtons } from './StoreSelectorButtons/StoreSelectorButtons';

export const testId = 'screen-storeSelector';

export function StoreSelector(): JSX.Element {
    // ***** Local State *****
    const [showErrors, setShowErrors] = useState(false);

    // ***** CONSTANTS *****
    const baseId = 'screen-storeSelector';

    return (
        <DisplayComponent baseId={baseId} data-testid={testId}>
            <Header />
            <Slogan />
            <ProgressBar />
            <StoreInput showErrors={showErrors} baseId={baseId} />
            <StoreSelectorButtons
                setShowErrors={setShowErrors}
                baseId={baseId}
            />
        </DisplayComponent>
    );
}
